import axios, { getData } from "lib/axios"
import { getCachedReadOnlyData } from "services/cache/readOnlyCache"

const ONE_DAY = 24 * 60 * 60 * 1000

export const companyTypes = async () => {
    return getCachedReadOnlyData(
        "dropdown:company-types",
        () => axios.get("/company-details-dropdown").then(getData),
        { ttl: ONE_DAY }
    )
}

export const countries = async () => {
    return getCachedReadOnlyData(
        "dropdown:countries",
        () => axios.get("/countries").then(getData),
        { ttl: ONE_DAY }
    )
}

export const banks = async () => {
    return getCachedReadOnlyData(
        "dropdown:banks",
        () => axios.get("/banks").then(getData),
        { ttl: ONE_DAY }
    )
}

export const departments = async () => {
    return axios.get("/department-list").then(getData)
}

export const salaryCategories = async () => {
    return getCachedReadOnlyData(
        "dropdown:salary-categories",
        () => axios.get("/salary-categories").then(getData),
        { ttl: ONE_DAY }
    )
}

export const profileDepartments = async () => {
    return axios.get("/departments-dropdown").then(getData)
}
